/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-15 14:28:12
 * @FilePath: /privacy-web/src/store/getters.js
 */
const getters = {
  count: state => state.app.count,
  loading: state => state.loading.pendingLength,
  isMobile: state => state.mobile.isMobile,
  htmlSize: state => state.mobile.htmlSize
}
export default getters
